<template>
  <div>
    <i class="fa fa-circle" :class="circleColor"></i>
    <span>&nbsp;{{ status.label.replace(' ', '&nbsp;') }}&nbsp;</span>
    <i v-if="saleRdvHaveDocuments" title="Documents de Cession reçus" class="fa fa-check text-success"></i>
    <div v-if="status.label !== status.transferStatusLabel || status.transferStatusId >= 1">
      <span v-if="hasP2PTransfer" class="badge" :class="badgeColor">&nbsp;{{ status.transferStatusLabel.replace(' ', '&nbsp;') }}&nbsp;</span>
    </div>
  </div>
</template>

<script>
/** order status **/
const TO_PLANIFY = 1
const TO_PREPARE = 2
const TO_DO = 3
const TO_FINALIZE = 4
const CANCELLED = 6
const SOLD = 7

/** transfer Status **/
const TO_DO_P2P = 1
const DONE = 2
const EXT = 3

export default {
  constants: {
    TO_PLANIFY: TO_PLANIFY,
    TO_PREPARE: TO_PREPARE,
    TO_DO: TO_DO,
    TO_FINALIZE: TO_FINALIZE,
    CANCELLED: CANCELLED,
    SOLD: SOLD,
    TO_DO_P2P: TO_DO_P2P,
    DONE: DONE,
    EXT: EXT,
  },

  props: {
    status: {
      type: Object,
      required: true
    },
    saleRdvHaveDocuments: {
      type: Boolean,
      default: false
    },
    hasP2PTransfer: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    documentInfo: null
  }),

  computed: {
    circleColor() {
      switch (parseInt(this.status.id)) {
        case TO_PLANIFY:
          return 'orange-circle'
        case TO_PREPARE:
          return 'blue-circle'
        case TO_DO:
          return 'dark-blue-circle'
        case TO_FINALIZE:
          return 'pink-circle'
        case CANCELLED:
          return 'red-circle'
        case SOLD:
          return 'green-circle'
        default:
          return ''
      }
    },
    badgeColor() {
      switch (parseInt(this.status.transferStatusId)) {
        case TO_DO_P2P:
          return 'badge-warning'
        case DONE:
          return 'badge-success'
        case EXT:
          return 'badge-primary'
        default:
          return ''
      }
    }
  }
}
</script>
